import React, {memo} from 'react';
import {useSelector} from 'react-redux';
import {selectMainPageLocationMode} from '@/app/store/config/selectors';
import {GeoAccessRequestDialog} from '@/app/components/common/GeoAccessRequestDialog';
import {useGeoPermission} from '@/app/hooks/useGeoPermission';
import styles from './GeoAccessRequest.css';

export const GeoAccessRequest = memo(() => {
	const mainPageLocationMode = useSelector(selectMainPageLocationMode);

	const {shown, handleClose} = useGeoPermission(mainPageLocationMode);

	if (!shown) {
		return null;
	}

	return <GeoAccessRequestDialog className={styles.root} onClose={handleClose} />;
});

GeoAccessRequest.displayName = 'GeoAccessRequest';
